const normalizeValue = (value?: string) =>
  value
    ?.trim()
    .toLowerCase()
    .replace(/[:\-\s]+/g, " ")
    .trim() || "";

const COLUMN_ALIASES: Record<string, string[]> = {
  item: ["item", "expense", "description"],
  status: ["status", "state"],
  invoicedDate: ["invoiced date", "invoice date", "date invoiced", "bill date"],
  dueDate: ["due date", "date due", "duedate"],
  amount: [
    "traveling amount",
    "travel amount",
    "amount",
    "expense amount",
    "total amount",
    "travelling amount",
    "traveling-amount",
    "travelling-amount",
  ],
  category: ["category", "categories"],
  business: ["business", "vendor", "merchant"],
  notes: ["alternatives?", "notes", "memo", "comments"],
};

const COLUMN_LABELS: Record<string, string> = {
  item: "Item / Expense column",
  amount: "Traveling Amount column",
  status: "Status column",
};

export interface ImportColumnIndices {
  itemIdx: number;
  statusIdx: number;
  invoicedDateIdx: number;
  dueDateIdx: number;
  amountIdx: number;
  categoryIdx: number;
  businessIdx: number;
  notesIdx: number;
  missingColumns: string[];
}

export function getImportColumnIndices(
  header: string[],
  required: (keyof typeof COLUMN_ALIASES)[] = ["item", "amount", "status"]
): ImportColumnIndices {
  const indexMap: Partial<Record<keyof typeof COLUMN_ALIASES, number>> = {};

  Object.entries(COLUMN_ALIASES).forEach(([key, aliases]) => {
    const idx = header.findIndex((value) =>
      aliases.includes(normalizeValue(value))
    );
    indexMap[key as keyof typeof COLUMN_ALIASES] = idx;
  });

  const missingColumns = required
    .filter((key) => (indexMap[key] ?? -1) === -1)
    .map((key) => COLUMN_LABELS[key]);

  return {
    itemIdx: indexMap.item ?? -1,
    statusIdx: indexMap.status ?? -1,
    invoicedDateIdx: indexMap.invoicedDate ?? -1,
    dueDateIdx: indexMap.dueDate ?? -1,
    amountIdx: indexMap.amount ?? -1,
    categoryIdx: indexMap.category ?? -1,
    businessIdx: indexMap.business ?? -1,
    notesIdx: indexMap.notes ?? -1,
    missingColumns,
  };
}
